import { render } from "./login-index.vue?vue&type=template&id=3b8c74db"
import script from "./login-index.vue?vue&type=script&lang=js"
export * from "./login-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__